export default {
    TOP_25: 'TOP_25',
    TOP_100: 'TOP_100',
    ALL_ACCOUNTS: 'ALL_ACCOUNTS',
    ALL_RECORDS_BY_DATE_RANGE: 'ALL_RECORDS_BY_DATE_RANGE',
    DISPLAYED_RECORDS: 'DISPLAYED_RECORDS',
    NO_OF_RECORDS: 'NO_OF_RECORDS'
};
